import { useRange, useRefinementList } from "react-instantsearch";

import Constants from "~/utils/constants";

import { useRatingMenu } from "./search-filter-reviews";

export default function Facets() {
  useRange({ attribute: "prices.value" });
  useRange({ attribute: "prices.formattedDiscountPerc" });
  useRatingMenu({ attribute: "averageRating" });

  useRefinementList({ attribute: "finishEffect", limit: Constants.MAX_NUMBER_VALUES_OF_FACET });
  useRefinementList({ attribute: "multicolor", limit: Constants.MAX_NUMBER_VALUES_OF_FACET });
  useRefinementList({ attribute: "coverage", limit: Constants.MAX_NUMBER_VALUES_OF_FACET });
  useRefinementList({ attribute: "waterproof" });
  useRefinementList({ attribute: "spf" });

  return null;
}
